import { render, staticRenderFns } from "./LocationReport.vue?vue&type=template&id=47da1f7b&"
import script from "./LocationReport.vue?vue&type=script&lang=ts&"
export * from "./LocationReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports